// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cuit: CountryValidator<"AR"> = createValidator(
  "ar.cuit",
  6,
);

export default cuit;
export const compact = cuit.compact;
export const format = cuit.format;
export const validate = cuit.validate;
export const generate = (): string =>
  cuit.generate?.() ??
  (() => {
    throw new Error(
      "Validator ar.cuit cannot generate values",
    );
  })();
